
export const loadScript = (source: string, id: string, callbackFn: (loaded: boolean, status: string) => void) => {
    const existingScript = document.getElementById(id);

    if (existingScript) {
        callbackFn(true, "loaded");
    } else {
        const script: any = document.createElement("script");
        script.setAttribute("id", id);
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", source);
    
        if (script.readyState) {
            //IE 11
            script.onreadystatechange = () => {
                if (script.readyState === "loaded" || script.readyState === "complete") {
                    script.onreadystatechange = null;
                    callbackFn(true, "loaded");
                }
            };
        } else {
            script.onload = () => {
                callbackFn(true, "loaded");
            };
        }
    
        script.onerror = (error: any) => {
            console.log(error);
            callbackFn(false, "error");
        };
    
        document.getElementsByTagName("head")[0].appendChild(script);
    }
};